import styled from 'styled-components';

const SecondaryBtnHigh = styled.button.attrs(props => ({
  type: props.type || 'button'
}))`
  font-family: inherit;
  padding: 6px 14px;
  font-size: .875rem;
  font-weight: 600;
  height: 37px;
  border-radius: 18px;
  border: none;
  color: ${props => props.theme.colors.white};
  cursor: pointer;
  background: ${props => props.theme.colors.darkbtn};
  white-space: nowrap;
  &.grey {
    background: #A3A3A3;
  }
  p {
    margin: 0;
  }
  &.disabled {
    cursor: auto!important;
  }
  svg {
    margin-right: 8px;
  }
  @media (max-width: 830px) {
    svg {
      margin-right: 4px;
    }
  }
`;

export default SecondaryBtnHigh;
